import { Question, QuestionAnswer } from '@core/types';
import { TextArea } from '@core/ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    question: Question;
    answer: QuestionAnswer | null;
    answerUpdated: (answer: QuestionAnswer) => void;
}

export const QuestionnaireOpenQuestion = ({ question, answer, answerUpdated }: Props) => {
    const [openAnswer, setOpenAnswer] = useState<string>('');
    const { t } = useTranslation();

    useEffect(() => {
        setOpenAnswer(answer?.openAnswer ?? '');
    }, [answer]);

    useEffect(() => {
        if (!openAnswer) {
            answerUpdated({ questionId: question.questionId });
            return;
        }

        answerUpdated({ questionId: question.questionId, openAnswer: openAnswer });
    }, [openAnswer]);

    return (
        <TextArea
            value={openAnswer}
            classNames="mb-2"
            textAreaClassNames="field-sizing-content"
            placeholder={t('Questionnaire.OpenQuestion.Placeholder')}
            onChange={(e) => setOpenAnswer(e.target.value)}
        ></TextArea>
    );
};
